import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Stack } from 'react-bootstrap';
import { useSocket } from '../../context/SocketContext';
import { DROPDOWN_ARROW, STAND_ICON, PLUS_ICON } from '../../assets/image';
import Chip from 'shared/UI/Chip';
import Dropdown from 'shared/UI/Dropdown';
import InviteMemberButton from 'pages/projects/kanban/shared/InviteMember/InviteMemberButton';
import EditableText from 'pages/projects/kanban/shared/EditableText';
import style from './MilestoneSetup.module.css';
import boardToast, { TOAST_TYPE } from '../../utils/boardToast';
import AvatarGroup from '../../shared/AvatarGroup';
import arrowDown from 'assets/img/arrow-down.svg';
import { ARROW_LEFT_ICON } from '../../assets/image';
import backIcon2 from 'assets/img/back-icon2.svg';
import { createProjectBoardSocket, getPlainText } from 'utils/Helpers';
import DueDateSelection from '../Task/DueDateSelection';
import LabelManager from '../../shared/LabelManager/LabelManager';
import CustomDatepicker from '../../shared/CustomDatepicker/CustomDatepicker';
import moment from 'moment-timezone';

export default function MileStoneSetup({
  milestone,
  priorityOptions,
  members,
  viewMode,
  projectBoardId,
  statusOptions,
  showSubTask,
  milestoneName,
  hideSubtask,
  subtaskId,
  projectTitle,
  onHide,
  defaultLabels,
  isMasterCalender,
  user,
  selectedMilestone,
  reminderOptions,
  showProfileModal,
  isClosedStatus
}) {
  const socket = useSocket();
  const [dueDate, setDueDate] = useState(milestone?.kbDueDate && new Date(milestone?.kbDueDate));
  const [priority, setPriority] = useState(milestone?.priority?._id);
  const [status, setStatus] = useState(milestone?.status?._id);
  const [name, setName] = useState(milestone?.name);
  const [backClicked, setBackClicked] = useState(false);
  const [labels, setLabels] = useState([]);
  const [isClose, setClose] = useState(milestone?.labelIds?.length == 0 || false);
  const [isLabelsBottom, setLabelsBottom] = useState(false);
  const [isOverdue, setOverdue] = useState(false);

  // Update state when milestone changes
  useEffect(() => {
    if (milestone) {
      setPriority(milestone.priority?._id || null);
      setLabels(milestone.labels || []);
      // console.log(priorityOptions);
      if (showSubTask) {
        setDueDate(milestone.dueDate ? new Date(milestone.dueDate) : null);
        setStatus(milestone?.status?._id || null);
      } else {
        const isOverdue = milestone?.kbDueDate && moment(milestone?.kbDueDate).endOf('day').isBefore(moment());
        setOverdue(isOverdue);
        setDueDate(milestone.kbDueDate ? new Date(milestone.kbDueDate) : null);
        setStatus(milestone?.milestoneKBStatus?._id || null);
      }
      setName(milestone.name || '');
    }
  }, [milestone]);

  const mergedPriorityOptions = useMemo(
    () => [{ label: 'Select', value: '' }, ...(priorityOptions || [])],
    [priorityOptions]
  );

  const handleChange = (value, isStatus) => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, selectedMilestone?.projectBoardId?._id);
      selectedBoardId = selectedMilestone?.projectBoardId?._id;
    }
    if (isStatus) {
      setStatus(value);
    } else {
      setPriority(value);
    }
    if (showSubTask) {
      console.log({ id: subtaskId, milestoneId: milestone.milestoneId, payload: { status: value?.value } });
      masterSocket?.emit(
        'update-subtask',
        {
          id: subtaskId,
          milestoneId: milestone.milestoneId,
          payload: { status: value?.value },
          projectBoardId: selectedBoardId
        }
        // selectedBoardId
      );
    } else {
      masterSocket?.emit('update-milestone', {
        projectBoardId: selectedBoardId,
        id: milestone._id,
        payload: { [isStatus ? 'milestoneKBStatus' : 'priority']: value?.value }
      });
    }
  };

  const handleDueDate = (
    date,
    kbDueDateReminders = [], // <-- NEW (array)
    hasTime = false
  ) => {
    let isAssigneeAvailable;
    let dueDateString = '';
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;

    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, selectedMilestone?.projectBoardId?._id);
      selectedBoardId = selectedMilestone?.projectBoardId?._id;
    }

    const validDate = date === null ? null : date instanceof Date ? date : new Date(date);

    if (validDate) {
      if (hasTime) {
        // Nov 20, 2025, 8:00 PM
        dueDateString = validDate.toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
      } else {
        // Nov 20, 2025
        dueDateString = validDate.toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }
    }

    // derived flag
    const kbDueDateReminderSet = Array.isArray(kbDueDateReminders) && kbDueDateReminders.length > 0;

    setDueDate(validDate);

    if (showSubTask) {
      isAssigneeAvailable = milestone.assignees.find((x) => x?._id === user._id);
    } else {
      isAssigneeAvailable = milestone.assigneeIds.find((x) => x?._id === user._id);
    }

    let payload = {
      // dueDate: validDate,
      // dueDateString,
      kbDueDateReminderSet,
      kbDueDateReminders // <-- NEW PAYLOAD
    };
    if (showSubTask) {
      payload.dueDate = validDate;
      payload.dueDateString = dueDateString;
    } else {
      payload.kbDueDate = validDate;
      payload.kbDueDateString = dueDateString;
    }
    console.log(payload, 'payloaddddddd');

    if (showSubTask) {
      masterSocket?.emit('update-subtask', {
        id: subtaskId,
        milestoneId: milestone.milestoneId,
        payload,
        projectBoardId: selectedBoardId
      });
    } else {
      masterSocket?.emit('update-milestone', {
        projectBoardId: selectedBoardId,
        id: milestone._id,
        payload
      });
    }

    // keep original behavior
    if (!isAssigneeAvailable && kbDueDateReminderSet) {
      handleMember(user);
    }
  };

  const handleUpdateMilestone = (data) => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, selectedMilestone?.projectBoardId?._id);
      selectedBoardId = selectedMilestone?.projectBoardId?._id;
    }
    if (showSubTask) {
      masterSocket?.emit(
        'update-subtask',
        { id: subtaskId, milestoneId: milestone.milestoneId, payload: { name: data }, projectBoardId: selectedBoardId }
        // selectedBoardId
      );
    } else {
      masterSocket?.emit('update-milestone', {
        projectBoardId: selectedBoardId,
        id: milestone._id,
        payload: { name: data }
      });
    }
  };

  const handleMember = (data) => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, selectedMilestone?.projectBoardId?._id);
      selectedBoardId = selectedMilestone?.projectBoardId?._id;
    }
    let ids = [];
    if (showSubTask) {
      ids = milestone.assignees.map((value) => value?._id || value);
      console.log(ids, 'assigneeeids');
      console.log(data._id);

      let payload = {
        milestoneId: milestone.milestoneId,
        name: milestone.name,
        dueDate: milestone.dueDate,
        assignees: [...ids, data._id]
      };
      masterSocket?.emit(
        'update-subtask',
        { id: subtaskId, milestoneId: milestone.milestoneId, payload, projectBoardId: selectedBoardId }
        // selectedBoardId
      );
    } else {
      ids = milestone.assigneeIds.map((value) => value?._id || value);
      masterSocket?.emit('update-milestone', {
        projectBoardId: selectedBoardId,
        id: milestone._id,
        payload: { assigneeIds: [...ids, data._id] },
        assignMemberType: 'invited',
        memberName: data.fullName
      });
    }
    boardToast('Member assign successfully', TOAST_TYPE.SUCCESS);
  };

  const handleRemove = (userId) => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, selectedMilestone?.projectBoardId?._id);
      selectedBoardId = selectedMilestone?.projectBoardId?._id;
    }
    let updatedUserIds = [];
    if (showSubTask) {
      updatedUserIds = milestone.assignees.map((value) => value?._id || value).filter((value) => value !== userId);
      let payload = {
        milestoneId: milestone.milestoneId,
        name: milestone.name,
        dueDate: milestone.dueDate,
        assignees: updatedUserIds
      };
      masterSocket?.emit(
        'update-subtask',
        { id: milestone._id, milestoneId: milestone.milestoneId, payload, projectBoardId: selectedBoardId }
        // selectedBoardId
      );
    } else {
      updatedUserIds = milestone.assigneeIds.map((value) => value?._id || value).filter((value) => value !== userId);
      const userName = milestone.assigneeIds.find((value) => value?._id === userId)?.fullName;
      masterSocket?.emit('update-milestone', {
        projectBoardId: selectedBoardId,
        id: milestone._id,
        payload: { assigneeIds: updatedUserIds },
        assignMemberType: 'removed',
        memberName: userName
      });
    }

    boardToast('Member removed successfully', TOAST_TYPE.SUCCESS);
  };
  const ExampleCustomInput = forwardRef(({ value, onClick, className }, ref) => (
    <div className={className} onClick={onClick} ref={ref}>
      {value ? value : 'Select Date'}
      <img src={DROPDOWN_ARROW} alt="arrow icon" className="icon-small ml-2" />
    </div>
  ));

  const handletoggleCompletetask = (milesoneId, value = false) => {
    // let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    socket?.emit('update-milestone', {
      id: milesoneId,
      payload: { isCompleted: value },
      projectBoardId: selectedBoardId
    });
  };

  return (
    <div>
      {/* {showSubTask && (
        <div
          className={style.back_title}
          onClick={() => {
            hideSubtask();
            setBackClicked(true);
          }}>
          {' '}
          <img src={ARROW_LEFT_ICON} alt="hello-icon" /> {milestoneName}
        </div>
      )} */}
      <div className={style.heading_with_icon_wrapper}>
        {/* <img src={STAND_ICON} alt="hello-icon" className={style.heading_icon} /> */}
        <div className="mr-2 w-90">
          {/* <div
            className={`${style.webApp_content} cursor_pointer`}
            onClick={() => {
              if (showSubTask) {
                hideSubtask();
                setBackClicked(true);
              } else {
                onHide();
              }
            }}>
            <img src={backIcon2} alt="backIcon2 icon" className={style.backIcon2} />
            <p>{showSubTask ? milestoneName : projectTitle}</p>
          </div> */}
          <EditableText
            handleSubmitTitle={(data) => {
              handleUpdateMilestone(data);
              setName(data);
            }}
            isEditor={showSubTask}
            title={name}
            hideEditButton={viewMode}
            backClicked={backClicked}
            setBackClicked={setBackClicked}
            isCompletedMilestone={milestone?.isCompleted}
            showCheckmark={viewMode ? false : !showSubTask}
            handletoggleCompletetask={() => handletoggleCompletetask(milestone._id, !milestone.isCompleted)}
          />
          {/* <div className={style.description}>
            <div>In List</div>
            <div>
              <Chip label={milestone?.status?.name} />
            </div>
          </div> */}
        </div>
      </div>
      <div className={style.milestone_setup_wrapper}>
        <div className={style.milestone_setup_content}>
          <div>
            <div className="subtitle1 mb-2">Status</div>
            <Dropdown
              value={status}
              className="dropdown-date-picker"
              options={statusOptions}
              onChange={(val) => {
                handleChange(val, true);
              }}
              disabled={viewMode}
            />
          </div>
          {!showSubTask && (
            <div>
              <div className="subtitle1 mb-2">Priority</div>
              <Dropdown
                value={priority}
                className="dropdown-date-picker"
                options={mergedPriorityOptions}
                onChange={(val) => {
                  handleChange(val, false);
                }}
                disabled={viewMode || isClosedStatus}
              />
            </div>
          )}
          <div>
            <div className="subtitle1 mb-2 completed-box">
              Due Date {milestone?.isCompleted ? <p className="completed-text">Completed</p> : ''}
            </div>
              <div
                className={`${style.dropdown_date_picker_wrapper} ${
                  viewMode || isClosedStatus ? style.disabled_data : ''
                }`}>
                {/* <DatePicker
                  selected={dueDate}
                  onChange={handleDueDate}
                  disabled={viewMode}
                  className="dropdown-date-picker"
                  placeholderText="Select Date"
                  showTimeSelect
                  dateFormat="MMM d, h:mm aa"
                  minDate={new Date()}
                  customInput={<ExampleCustomInput className="example-custom-input" />}
                /> */}
                <CustomDatepicker
                  defaultDate={dueDate}
                  handleDueDate={handleDueDate}
                  reminderOptionsData={reminderOptions}
                  milestone={milestone}
                  viewMode={viewMode}
                  isClosedStatus={isClosedStatus}
                />
                {/* <DueDateSelection
                  showTimeSelect={true}
                  handleDueDate={handleDueDate}
                  dueDate={new Date(dueDate)}
                  extraClass={"dropdown-date-picker"}
                  showText={true}
                  dateFormat="MMM d, h:mm aa"
                  isOpen={true}
                  // isDisabled={disabled}
                /> */}
              </div>
          </div>

          {((!showSubTask && milestone?.assigneeIds?.length < 5) || showSubTask) && (
            <div>
              <div className="subtitle1 mb-2">Member</div>
              <Stack direction="horizontal" gap={2}>
                <div className="d-flex">
                  <AvatarGroup
                    members={showSubTask ? milestone?.assignees : milestone.assigneeIds}
                    limit={4}
                    size={30}
                    handleRemove={handleRemove}
                    showRemove={true}
                    showProfileModal={showProfileModal}
                    isfromMilestoneModal={true}
                    viewMode={isClosedStatus || viewMode}
                  />
                </div>

                {!viewMode && !isClosedStatus ? (
                  <InviteMemberButton
                    assignees={showSubTask ? milestone?.assignees : milestone.assigneeIds}
                    members={members}
                    handleMember={handleMember}
                    handleRemove={handleRemove}
                  />
                ) : (
                  <button className="btn btn-light icon-btn-round">
                    <img src={PLUS_ICON} alt="plus-icon" />
                  </button>
                )}
              </Stack>
            </div>
          )}
          {(!milestone.labelIds || milestone.labelIds.length == 0 || isClose) && (
            <div>
              <div className="subtitle1 mb-2">Labels</div>
              <LabelManager
                projectBoardId={projectBoardId}
                defaultLabels={defaultLabels}
                milestone={milestone}
                setClose={setClose}
                showLabels={false}
                setLabelsBottom={setLabelsBottom}
                makeSetCloseChanges={true}
                isMasterCalender={isMasterCalender}
                showSubTask={showSubTask}
                viewMode={viewMode || isClosedStatus}
              />
            </div>
          )}
        </div>
      </div>
      {((milestone?.labelIds && milestone?.labelIds?.length > 0) || isLabelsBottom) && (
        <div className={style.milestone_setup_wrapper}>
          <div className="subtitle1 mb-2">Labels</div>
          <LabelManager
            projectBoardId={projectBoardId}
            defaultLabels={defaultLabels}
            milestone={milestone}
            setClose={setClose}
            showLabels={true}
            setLabelsBottom={setLabelsBottom}
            makeSetCloseChanges={false}
            isMasterCalender={isMasterCalender}
            showSubTask={showSubTask}
            viewMode={viewMode || isClosedStatus}
          />
        </div>
      )}

      {!showSubTask && milestone?.assigneeIds?.length > 4 && (
        <div className={style.milestone_setup_wrapper}>
          <div>
            <div className="subtitle1 mb-2">Member</div>
            <Stack direction="horizontal" gap={2}>
              <div className="d-flex">
                <AvatarGroup
                  members={showSubTask ? milestone?.assignees : milestone.assigneeIds}
                  limit={10}
                  size={30}
                  handleRemove={handleRemove}
                  showRemove={true}
                  viewMode={isClosedStatus || viewMode}
                />
              </div>

              {!viewMode && !isClosedStatus ? (
                <InviteMemberButton
                  assignees={showSubTask ? milestone?.assignees : milestone.assigneeIds}
                  members={members}
                  handleMember={handleMember}
                  handleRemove={handleRemove}
                />
              ) : (
                <button className="btn btn-light icon-btn-round">
                  <img src={PLUS_ICON} alt="plus-icon" />
                </button>
              )}
            </Stack>
          </div>
        </div>
      )}
    </div>
  );
}
